import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button, Grid, Card, CardContent } from '@mui/material';
import stories from './stories';

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const trackRef = useRef(null);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? stories.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === stories.length - 1 ? 0 : prev + 1));
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      handleNext();
    } else if (touchEndX.current - touchStartX.current > 50) {
      handlePrev();
    }
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <Box
        ref={trackRef}
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {stories.map((story, index) => (
          <Box
            key={index}
            sx={{
              position: index === currentIndex ? 'relative' : 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              opacity: index === currentIndex ? 1 : 0,
              visibility: index === currentIndex ? 'visible' : 'hidden',
              transition: 'opacity 0.5s ease, visibility 0.5s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              boxSizing: 'border-box',
              padding: '20px',
              flexDirection: { xs: 'column', md: 'row' },
            }}
          >
            <Box sx={{ flex: 1, maxWidth: { xs: '100%', md: '50%' } }}>
              <img
                src={story.image}
                alt={story.title}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Box sx={{ flex: 1, padding: '20px' }}>
              <Typography variant="h4" gutterBottom>
                {story.title}
              </Typography>
              <Typography variant="body1" paragraph>
                {story.description}
              </Typography>
              <Grid container spacing={2}>
                {story.stats.map((stat, statIndex) => (
                  <Grid item xs={12} sm={4} key={statIndex}>
                    <Card
                      sx={{
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          transform: 'translateY(-5px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                        },
                      }}
                    >
                      <CardContent>
                        <Typography variant="h6" color="primary">
                          {stat.value}
                        </Typography>
                        <Typography variant="body2">{stat.label}</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => alert(`Read story: ${story.title}`)}
              >
                Read the Story
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
      <Button
        sx={{
          position: 'absolute',
          top: '50%',
          left: '10px',
          transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 10,
          minWidth: 'auto',
        }}
        onClick={handlePrev}
      >
        &lt;
      </Button>
      <Button
        sx={{
          position: 'absolute',
          top: '50%',
          right: '10px',
          transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          padding: '10px',
          cursor: 'pointer',
          zIndex: 10,
          minWidth: 'auto',
        }}
        onClick={handleNext}
      >
        &gt;
      </Button>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mt: '20px' }}>
        {stories.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              background: index === currentIndex ? '#1976d2' : '#ccc',
              cursor: 'pointer',
            }}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Carousel;